'use client';
import { __rest } from 'tslib';
import { CaretLeftIcon, CaretRightIcon } from '@radix-ui/react-icons';
import React from 'react';
import { styled } from '../stitches.config.js';
import { TriangleNav } from './TriangleNav.js';

const Container = styled('div', {
    left: 0, right: 0, position: 'relative', display: 'flex', alignItems: 'center', gap: 15,
    variants: {
        layout: {
            compact: {
                justifyContent: 'center',
            },
            expanded: {
                width: '100%',
                justifyContent: 'space-between'
            }
        }
    }
});
const Flex = styled('div', { display: 'flex', alignItems: 'center' });
const DirectionNav = (_a) => {
    var { children, type = 'triangle', navCSS, layout = "expanded" } = _a, props = __rest(_a, ["children", "type", "navCSS", "layout"]);
    const Nav = type === 'caret' ? CaretNav : TriangleNav;
    return (React.createElement(Container, { layout: layout, css: props.containerCSS },
        React.createElement(Nav, { css: navCSS, height: props.height, direction: "left", fn: props.handleLeft }),
        React.createElement(Flex, null, children),
        React.createElement(Nav, { css: navCSS, height: props.height, direction: "right", fn: props.handleRight })));
};
const caretNavStyles = {
    width: 30, height: 30, zIndex: 10
};
const CaretLeft = styled(CaretLeftIcon, caretNavStyles);
const CaretRight = styled(CaretRightIcon, caretNavStyles);
const CaretNav = ({ css = {}, height, fn, direction }) => {
    const Icon = direction === 'left' ? CaretLeft : CaretRight;
    return React.createElement(Icon, { css: Object.assign(Object.assign({}, css), (height !== undefined && { height })), onClick: fn });
};

export { DirectionNav };
